import { api } from 'utils';

import {
  FetchListOneApiResponse,
  FetchListOneTicketDetailsApiResponse,
  FetchListOneTicketStudiesApiResponse,
  FetchListOneStatusesApiResponse,
  DeleteListOneOpenPendingTicketApiResponse,
  FixAndPromoteTicketApiResponse,
  FetchApprovalApiResponse,
  ApproveTicketApiResponse,
} from './api.types';

export async function fetchListOneApi(filter: any) {
  return await api().get<FetchListOneApiResponse>('/tickets/fetch', {
    params: {
      page: filter.exportable ? undefined : filter.page,
      limit: filter.exportable ? undefined : filter.rows,
      type: filter.ticketType === 'All' ? '' : filter.ticketType,
      status: filter.ticketStatus === 'All' ? '' : filter.ticketStatus,
      minDate: filter.startDate,
      maxDate: filter.endDate,
      searchString: filter.employeeId,
      personId: filter.personId,
      country: filter.country,
      exportable: filter.exportable,
      statusCodes: filter.statusCodes,
    },
  });
}

export async function fetchListOneTicketDetailsApi({ queryKey }: any) {
  const [, , , ticketId] = queryKey;

  return api().get<FetchListOneTicketDetailsApiResponse>(`/ticket/fetch/info`, {
    params: { id: ticketId },
  });
}

export async function fetchListOneTicketHistoryInfoApi({ queryKey }: any) {
  const [, , , params] = queryKey;

  return api().get(`/ticket/history/info`, {
    params: { id: params.studyId, ticketId: params.ticketId },
  });
}

export async function fetchListOneTicketStudiesApi({ queryKey }: any) {
  const [, , ticketId] = queryKey;

  return api().get<FetchListOneTicketStudiesApiResponse>('/tickets/history', {
    params: {
      ticketId,
    },
  });
}

export async function fetchListOneStatusesBriefApi({ queryKey }: any) {
  const [, , , params] = queryKey;

  return api().get<FetchListOneStatusesApiResponse>('/tickets/status/brief', {
    params: {
      page: params.exportable ? undefined : params.page,
      limit: params.exportable ? undefined : params.rows,
      type: params.ticketType === 'All' ? '' : params.ticketType,
    },
  });
}

export async function deleteListOneOpenPendingTicketApi(ticketId: string) {
  return api().delete<DeleteListOneOpenPendingTicketApiResponse>(
    `/list/AD/deletion?ticketId=${ticketId}`
  );
}

export async function fixAndPromoteTicketApi(data: {
  ticketId: string;
  statusId: number;
  fixData?: {
    healthPolicyId?: string;
    lifePolicyId?: string;
    fields?: { field: string; oldValue?: string; newValue?: string }[];
  };
}) {
  return api().post<FixAndPromoteTicketApiResponse>(
    '/list/fix-and-promote',
    data
  );
}

export async function fetchListOneApprovalApi({ queryKey }: any) {
  const [, , ticketId] = queryKey;

  return api().get<FetchApprovalApiResponse>('/list/approval', {
    params: { ticketId },
  });
}

export async function updateApprovalCaseApi(data: {
  ticketId: string;
  subCase?: string | null;
  answers?: Record<string, boolean>;
}) {
  return api().patch('/list/approval/case', data);
}

export async function uploadApprovalDocumentApi(data: {
  ticketId: string;
  documentKey: string;
  file: File;
}) {
  const form = new FormData();
  form.append('ticketId', data.ticketId);
  form.append('documentKey', data.documentKey);
  form.append('file', data.file);

  return api().post('/list/approval/document', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export async function deleteApprovalDocumentApi(data: {
  ticketId: string;
  documentKey: string;
}) {
  return api().delete('/list/approval/document', {
    params: { ticketId: data.ticketId, documentKey: data.documentKey },
  });
}

export async function approveListOneTicketApi(data: { ticketId: string }) {
  return api().post<ApproveTicketApiResponse>('/list/approval/approve', data);
}
